import React, { useRef, useState } from 'react';
import { Modal, Button, Alert, Table } from 'react-bootstrap';
import { API_BASE, getAuthHeaders } from '../utils/api';

const CSV_TEMPLATE = 'nome,cargo,acesso,numero_telefone\nJOAO SILVA,EDITOR,colaborador,11999990000\nMARIA SOUZA,ROTEIRISTA,colaborador,11988880000';

const ModalImportarCSV = ({ show, onHide, onSuccess, token }) => {
  const fileRef = useRef();
  const [preview, setPreview] = useState([]);
  const [resultado, setResultado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  const parseCSV = (text) => {
    const [header, ...rows] = text.trim().split('\n');
    const cols = header.split(',').map(c => c.trim().toLowerCase());
    return rows.filter(r => r.trim()).map(r => {
      const vals = r.split(',');
      return cols.reduce((obj, col, i) => { obj[col] = (vals[i] || '').trim(); return obj; }, {});
    });
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setResultado(null); setErro('');
    const reader = new FileReader();
    reader.onload = (ev) => {
      try { setPreview(parseCSV(ev.target.result)); }
      catch { setErro('Arquivo inválido. Verifique o formato CSV.'); }
    };
    reader.readAsText(file);
  };

  const handleImportar = async () => {
    if (!preview.length) return;
    setLoading(true); setErro('');
    try {
      const res = await fetch(`${API_BASE}/users/batch`, {
        method: 'POST',
        headers: { ...getAuthHeaders(token), 'Content-Type': 'application/json' },
        body: JSON.stringify(preview)
      });
      const data = await res.json();
      setResultado(data);
      if (data.criados?.length) onSuccess();
    } catch {
      setErro('Erro ao conectar com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => { setPreview([]); setResultado(null); setErro(''); onHide(); };

  const downloadTemplate = () => {
    const blob = new Blob([CSV_TEMPLATE], { type: 'text/csv' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'modelo_usuarios.csv';
    a.click();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title><i className="bi bi-file-earmark-spreadsheet me-2"></i>Importar Usuários via CSV</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <small className="text-muted">Colunas: <code>nome, cargo, acesso, numero_telefone</code></small>
          <Button size="sm" variant="outline-secondary" onClick={downloadTemplate}>
            <i className="bi bi-download me-1"></i>Baixar Modelo
          </Button>
        </div>
        <input ref={fileRef} type="file" accept=".csv" className="form-control mb-3" onChange={handleFile} />
        {erro && <Alert variant="danger" className="py-2">{erro}</Alert>}
        {preview.length > 0 && !resultado && (
          <>
            <div className="text-muted small mb-2">{preview.length} usuário(s) encontrado(s) no arquivo:</div>
            <div style={{ maxHeight: 220, overflowY: 'auto' }}>
              <Table size="sm" bordered className="mb-0">
                <thead className="table-light">
                  <tr><th>Nome</th><th>Cargo</th><th>Acesso</th><th>Telefone</th></tr>
                </thead>
                <tbody>
                  {preview.map((u, i) => (
                    <tr key={i}><td>{u.nome}</td><td>{u.cargo}</td><td>{u.acesso}</td><td>{u.numero_telefone || '-'}</td></tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>
        )}
        {resultado && (
          <Alert variant={resultado.erros?.length ? 'warning' : 'success'}>
            <div><i className="bi bi-check-circle me-1"></i>{resultado.criados?.length || 0} usuário(s) criado(s) com sucesso.</div>
            {resultado.senha_padrao && (
              <div className="mt-2 p-2 rounded" style={{ backgroundColor: 'rgba(0,0,0,0.05)' }}>
                Senha padrão dos usuários criados: <strong style={{ fontFamily: 'monospace', letterSpacing: '1px' }}>{resultado.senha_padrao}</strong>
              </div>
            )}
            {resultado.erros?.length > 0 && (
              <div className="mt-1"><i className="bi bi-exclamation-triangle me-1"></i>{resultado.erros.length} erro(s): {resultado.erros.map(e => `${e.nome} (${e.erro})`).join(', ')}</div>
            )}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Fechar</Button>
        {preview.length > 0 && !resultado && (
          <Button style={{ backgroundColor: 'var(--brand-primary)', border: 'none' }} onClick={handleImportar} disabled={loading}>
            {loading
              ? <><span className="spinner-border spinner-border-sm me-2" />Importando...</>
              : <><i className="bi bi-upload me-1"></i>Importar</>}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalImportarCSV;
